import { render, staticRenderFns } from "./CustomMessage.vue?vue&type=template&id=18a28d9a&scoped=true&"
import script from "./CustomMessage.vue?vue&type=script&lang=js&"
export * from "./CustomMessage.vue?vue&type=script&lang=js&"
import style0 from "./CustomMessage.vue?vue&type=style&index=0&id=18a28d9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a28d9a",
  null
  
)

export default component.exports